import styled from 'styled-components';

export const Wrapper = styled.div`
  & + & {
    margin-top: 24px;
  }

  /* Override max-width on BaseInput */
  > div {
    max-width: 485px;
  }
`;
